import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from "../../../components/Icon";
import Close from "../../../icons/close.svg";
import { useTranslations } from "../../../providers/useTranslations";
import { DrawerCloseTrigger } from "./DrawerCloseTrigger";
import styles from "../Drawer.module.scss";
export const DrawerHeader = ({ children, ...restProps }) => {
    const { __ } = useTranslations();
    return (_jsxs("header", { className: styles.drawerHeader, "data-testid": "drawer-header", ...restProps, children: [_jsx("div", { className: styles.drawerHeadline, children: children }), _jsx(DrawerCloseTrigger, { children: _jsx("button", { type: "button", className: styles.drawerCloseButton, title: __("drawer.close", [], "Close"), "data-testid": "close-drawer-button", children: _jsx(Icon, { component: Close }) }) })] }));
};
DrawerHeader.displayName = "DrawerHeader";
//# sourceMappingURL=DrawerHeader.js.map